import React, { useState, useRef, useEffect } from 'react';
import { IoMdArrowDropdown } from 'react-icons/io';
import NavigationMenu from './NavigationMenu';
import PremiumServices from './premiumServices';
import { ComingSoonModal } from '../../ComingSoonModal/ComingSoonModal';
import useCustomNavigate from '../../../hooks/useCustomNavigate';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const SubNavBar = () => {

  const { goTo, goToNewTab } = useCustomNavigate()

  const locationPath = useLocation().pathname;
  const isHome = locationPath === "/";

  const [hoveredItem, setHoveredItem] = useState('');
  const [modalOpen, setModalOpen] = useState(false);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [expandedCategory, setExpandedCategory] = useState("");
  const navRefs = useRef([]);  // Use an array of refs for each navigation item

  const [isHidden, setIsHidden] = useState(false); // Track visibility
  const [scrolled, setScrolled] = useState(false); // 👈 new state
  const prevScrollY = useRef(0); // Store previous scroll position


  // Add or update a ref in an array
  const addToRefs = (el, index) => {
    if (el && !navRefs.current.includes(el)) {
      navRefs.current[index] = el;
    }
  };



  const currentLocationDetails = useSelector((state) => state?.counter?.location);

  const encodeLocationDetails = () => {
    const locationData = {
      city: currentLocationDetails?.city || '',
      state: currentLocationDetails?.state || '',
      country: currentLocationDetails?.country || ''
    };
    return encodeURIComponent(JSON.stringify(locationData));
  };


  const categoryParentMapping = {
    Buy: "Sell",
    Rent: "Rent",
  };


  const handleNavigation = (item, category) => {
    const locationQuery = encodeLocationDetails();
    const parentCategory = categoryParentMapping[category] || '';
    const parentQuery = parentCategory ? `&parentCategory=${encodeURIComponent(parentCategory)}` : '';

    if (item.url) {
      goToNewTab(item.url, "_blank");
    } else {
      const formattedCategory = encodeURIComponent(item.replace(/ /g, '-'));
      goToNewTab(`/searchresult/bycategory?category=${formattedCategory}&location=${locationQuery}${parentQuery}`);
    }
  };





  const toggleCategory = (category) => {
    setExpandedCategory((prev) => (prev === category ? "" : category));
  };

  const categories = {
    Buy: [
      { name: "Property Types", items: ["Residential", "Commercial", "Industrial", "Agricultural"] },
      { name: "Property Choices", items: ["Furnished", "Unfurnished", "Under Construction", "Ready to Move"] },
      { name: "Explore", items: ["Investment Ideas", "Property Valuation", "Guidance"] },
      { name: "Budget", items: ["10 to 15 lakh", "Above 50 lakh", "7 crore", "Above 7 crore"] },
      { name: "New Projects", items: ["AD.. locality"] },
    ],
    Rent: [
      { name: "Property Types", items: ["Flats", "PG", "Villa", "House", "Office Space"] },
      { name: "Popular Choices", items: ["Owner Properties", "Agent Property", "Verified", "Available Now!"] },
      { name: "Budget", items: ["Under 9000", "9000 to 18000", "18000 to 24000", "Above 24000"] },
      { name: "Services", items: ["Hire Agents", "Property Services", "Rent Agreement"] },
    ],
    Sell: [
      { name: "", items: [{ name: "My Dashboard", url: "https://one-two-one-admin-panel.vercel.app" }, { name: "Post Property", url: "/addproperty" }] },
      { name: "", items: [{ name: "Post New Projects", url: "/addproject" }, "Advertisement Packages"] },
      { name: "", items: ["Plans"] },
    ],
    "PROPERTY MANAGER": [{ name: "", items: ["Hire a Manager"] }],
    "Premium Services": [],
    Plans: [{ name: "", items: ["Silver", "Gold", "Platinum"] }],
  };


  const BuyCategories = [
    {
      name: 'Property Types',
      items: ['Residential', 'Commercial', 'Industrial', 'Agricultural']
    },
    {
      name: 'Property Choices',
      items: ['Furnished Property', 'Unfurnished property', 'Under Construction', 'ready to move', 'owner property', 'Agent Property']
    },
    {
      name: 'Explore',
      items: ['Investment Ideas', 'Property valuation', 'Guidance']
    },
    {
      name: 'Budget',
      items: ['10 to 15 lakh', 'above 50 lakh', '7 crore', 'above 7 crore']
    },

    {
      name: 'New Projects',
      items: ['AD.. locality',]
    },
  ];

  const RentCategories = [
    {
      name: 'Property Types',
      items: ['Flats', 'Flat mate', "PG", 'Villa', 'House', 'Co-live Space', 'Office Space', "Commericial Space"]
    },
    {
      name: 'Popular Choices',
      items: ['Owner Properties', 'Agent Property', 'Verified', "Bachelors", "Available Now!!"]
    },
    {
      name: 'Budget',
      items: ['Under 9000', '9000 to 18000', '18000 to 24000', 'Above 24000']
    },
    {
      name: 'Services',
      items: ['Hire Agents', { name: 'Property Services', onItemClick: (() => goTo("/property-services")) }, 'Rent Agreement', 'Pay Rent', 'Rental furniture']
    },
  ];



  const SellCategories = [
    {
      name: '',
      items: [
        { name: "My Dashboard", url: "https://one-two-one-admin-panel.vercel.app" },
        { name: "Post Property", url: "/addproperty" },
      ]
    },
    {
      name: '',
      items: [
        { name: "Post New Projects", url: "/addproject" },
        { name: "Advertisement packages", onItemClick: () => setModalOpen(true) }

      ]
    },
  ];




  const PlansCategories = [
    {
      name: '',
      items: ["Silver", "Gold", "Platinum"]
    },
  ]


  const RelationManagementCategories = [
    {
      name: '',
      items: ['Hire a Manager']
    },
  ];


  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;
      setScrolled(currentScroll > 10); // 👈 toggle class based on scroll

      if (currentScroll > 10) {
        if (currentScroll > prevScrollY.current) {
          setIsHidden(true);
        } else {
          setIsHidden(false);
        }
      }
      prevScrollY.current = window.scrollY; // Update previous scroll position
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll); // Cleanup listener on unmount
  }, []);



  return (
    <>
      <div
        className={`fixed top-[72px] w-full z-10 transition-transform duration-300 ease-in-out ${isHidden ? 'transform -translate-y-full' : 'transform translate-y-0'
          } ${isHome
            ? scrolled
              ? 'bg-white/60 backdrop-blur-md'
              : 'bg-transparent'
            : 'bg-white/60 backdrop-blur-md shadow-md border-gray-300'
          }`}
      >
        <div
          className={`hidden md:flex space-x-5 pl-10 items-center ${isHome ? (scrolled ? 'text-black' : 'text-white') : 'text-black'
            } pointer-events-auto`}
        >
          {['Buy', 'Rent', 'Sell', 'PROPERTY MANAGER', 'Premium Services', 'Plans'].map((item, index) => (
            <div
              key={index}
              ref={(el) => addToRefs(el, index)}
              className="relative flex flex-col items-center p-2 cursor-pointer group justify-center transition-all duration-300"
              onMouseEnter={() => setHoveredItem(item)}
              onMouseLeave={() => setHoveredItem('')}
            >
              <div className="flex items-center space-x-1">
                <span className="text-[16px] font-medium transition-all duration-300 
            group-hover:text-transparent 
            group-hover:bg-clip-text 
            group-hover:bg-gradient-to-r 
            group-hover:from-indigo-500 
            group-hover:via-sky-500 
            group-hover:to-emerald-400"
                >
                  {item}
                </span>
                <IoMdArrowDropdown className="text-[18px] transition-all duration-300 
            group-hover:text-indigo-500" />
              </div>

             
            </div>
          ))}
        </div>
      </div>




      {hoveredItem === 'Buy' && navRefs.current[0] && (
        <div
          className="fixed z-50"
          style={{
            top: navRefs.current[0].getBoundingClientRect().bottom,
            left: navRefs.current[0].getBoundingClientRect().left  // Position submenu under "Buy"
          }}
          onMouseEnter={() => setHoveredItem('Buy')}
          onMouseLeave={() => setHoveredItem('')}
        >
          <NavigationMenu categories={BuyCategories} parentCategory="Sell" />
        </div>
      )}
      {hoveredItem === 'Rent' && navRefs.current[1] && (
        <div
          className="fixed z-50"
          style={{
            top: navRefs.current[1].getBoundingClientRect().bottom,
            left: navRefs.current[1].getBoundingClientRect().left  // Position submenu under "Buy"
          }}
          onMouseEnter={() => setHoveredItem('Rent')}
          onMouseLeave={() => setHoveredItem('')}
        >
          <NavigationMenu categories={RentCategories} parentCategory="Rent" />
        </div>
      )}
      {hoveredItem === 'Sell' && navRefs.current[2] && (
        <div
          className="fixed z-50"
          style={{
            top: navRefs.current[2].getBoundingClientRect().bottom,
            left: navRefs.current[2].getBoundingClientRect().left  // Position submenu under "Buy"
          }}
          onMouseEnter={() => setHoveredItem('Sell')}
          onMouseLeave={() => setHoveredItem('')}
        >
          <NavigationMenu categories={SellCategories} />
        </div>
      )}
      {hoveredItem === 'Premium Services' && navRefs.current[4] && (
        <div
          className="fixed z-50"
          style={{
            top: navRefs.current[4].getBoundingClientRect().bottom,
            // left: navRefs.current[4].getBoundingClientRect().left  // Position submenu under "Buy"
            left: "20%",
            right: "20%"
          }}
          onMouseEnter={() => setHoveredItem('Premium Services')}
          onMouseLeave={() => setHoveredItem('')}
        >
          <PremiumServices setHoveredItem={setHoveredItem} />
        </div>
      )}

      {hoveredItem === 'PROPERTY MANAGER' && navRefs.current[3] && (
        <div
          className="fixed z-50"
          style={{
            top: navRefs.current[3].getBoundingClientRect().bottom,
            left: navRefs.current[3].getBoundingClientRect().left
          }}
          onMouseEnter={() => setHoveredItem('PROPERTY MANAGER')}
          onMouseLeave={() => setHoveredItem('')}
        >
          <NavigationMenu
            categories={RelationManagementCategories}
            onItemClick={() => goTo("/relationship/management")}
          />
        </div>
      )}



      {hoveredItem === 'Plans' && navRefs.current[5] && (
        <div
          className="fixed z-50"
          style={{
            top: navRefs.current[5].getBoundingClientRect().bottom,
            left: navRefs.current[5].getBoundingClientRect().left  // Position submenu under "Buy"
          }}
          onMouseEnter={() => setHoveredItem('Plans')}
          onMouseLeave={() => setHoveredItem('')}
        >
          <NavigationMenu categories={PlansCategories} onItemClick={() => setModalOpen(true)} />
        </div>
      )}


      {/*  mobile resposne  */}

      <div className="bg-[#0A192F] fixed top-[72px] w-full text-[#B0B0B0] z-50 md:hidden">
        <div className="flex items-center justify-between px-4 py-3 md:px-10" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>

          {/* Left Side - Title */}
          <span className="text-lg font-semibold text-white">Explore Properties</span>

          {/* Right Side - Toggle Button with Rotating Arrow */}
          <button className="md:hidden flex items-center text-2xl text-white">
            <IoMdArrowDropdown className={`transition-transform duration-300 ${mobileMenuOpen ? "rotate-180" : ""}`} />
          </button>
        </div>

        {/* Mobile Dropdown Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-[#0A192F] text-white flex flex-col px-4 py-3 max-h-[70vh] overflow-y-auto">
            {Object.keys(categories).map((item, index) => (
              <div key={index} className="border-b border-gray-600 py-2">
                <button
                  className="flex items-center justify-between w-full text-left text-lg"
                  onClick={() => toggleCategory(item)}
                >
                  {item} <IoMdArrowDropdown className={`transition-transform duration-300 ${expandedCategory === item ? "rotate-180" : ""}`} />
                </button>
                {expandedCategory === item && (
                  <div className="pl-4 mt-2 text-gray-300">
                    {categories[item].map((sub, idx) => (
                      <div key={idx} className="py-1">
                        <span className="font-semibold">{sub.name}</span>
                        <ul>
                          {sub.items.map((i, subIdx) => (
                            <li key={subIdx} className="text-sm py-1">
                              {typeof i === "string" ? (
                                <button onClick={() => handleNavigation(i, item)}>{i}</button>
                              ) : (
                                <a href={i.url} target="_blank" rel="noopener noreferrer">{i.name}</a>
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>


      <ComingSoonModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />

    </>
  );
};

export default SubNavBar;
